import React from 'react';

export function AtualizacaoSuporte({ modalData }) {
  console.log('modalData', modalData);

  return (
    <div>
      {modalData?.data?.nome ? (
        <p>
          <b>Nome do arquivo: </b> {modalData?.data?.nome}
        </p>
      ) : (
        ''
      )}

      {modalData?.responsavel?.nomeUsuario ? (
        <p>
          <b>Responsável: </b> {modalData?.responsavel?.nomeUsuario}
        </p>
      ) : (
        ''
      )}

      {modalData?.responsavel?.nomeUsuario ? (
        <p>
          <b>Responsável: </b> {modalData?.responsavel?.nomeUsuario}
        </p>
      ) : (
        ''
      )}

      {modalData?.responsavel?.nomeUsuario ? (
        <p>
          <b>Responsável: </b> {modalData?.responsavel?.nomeUsuario}
        </p>
      ) : (
        ''
      )}

      {modalData?.responsavel?.nomeUsuario ? (
        <p>
          <b>Responsável: </b> {modalData?.responsavel?.nomeUsuario}
        </p>
      ) : (
        ''
      )}
    </div>
  );
}
